import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import CurrentYear from './CurrentYear';
import {contact} from '../data/contact';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div>
          <div className="brand footer-brand" aria-label="Duran Media">
            <span className="brand-mark" aria-hidden="true">D</span>
            <span aria-hidden="true">
              DURAN <b>MEDIA</b>
            </span>
          </div>
          <p>
            {contact.name} <br />
            {contact.street} <br />
            {contact.city}
          </p>
        </div>
        <div className="footer-links">
          <div>
            <span>Explore</span>
            <Link to="/services">Services</Link>
            <Link to="/demos">Demos</Link>
            <Link to="/about">About</Link>
          </div>
          <div>
            <span>Connect</span>
            <Link to="/contact">Start a project</Link>
            <a href={`mailto:${contact.email}`}>{contact.email}</a>
            <a href={contact.phoneHref}>{contact.phone}</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          © <CurrentYear /> Duran Media Solutions.
        </p>
        <div className="socials" aria-label="Social media">
          <a
            href={contact.facebookUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Duran Media on Facebook"
          >
            <SafeIcon name="Facebook" aria-hidden="true" focusable="false" />
          </a>
          <a
            href={contact.youtubeUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Duran Media on YouTube"
          >
            <SafeIcon name="Youtube" aria-hidden="true" focusable="false" />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;